export default function Invitation() {
  return (
    <section className="relative w-full py-28 md:py-40 px-6 md:px-10 lg:px-14 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={`${import.meta.env.BASE_URL}localized/invitation-steam-01.jpg`}
          alt="Steaming cup"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/80 via-primary-950/60 to-primary-950/40"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center reveal">
        <span className="text-xs tracking-[0.35em] uppercase text-accent-300">An Invitation</span>
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-background-50 mt-6 mb-8 leading-tight">
          Slow down for a cup with us.
        </h2>
        <p className="text-background-200 leading-relaxed max-w-2xl mx-auto mb-10 text-lg">
          Whether it&apos;s a bag shipped to your kitchen or a corner seat at the Burnside cafe — we saved a warm one for you.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#coffee"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>Shop the Roast</span>
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="#visit"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-background-50/60 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-map-pin-2-line w-4 h-4 flex items-center justify-center"></i>
            <span>Visit The Cafe</span>
          </a>
        </div>
      </div>
    </section>
  );
}